import React from "react";
import footer from "./footer.css";

export default function Footer(){
    return(
        <div className="footer">
             <p className="heading-footer">Dice Game | HTML, CSS, JS, REACT.JS | Atul Sanodiya</p>
        </div>
    );
}